import type { GetDocumentAssessmentResultAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetDocumentAssessmentResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetDocumentAssessmentResultAuditByIdArgs = {
  id: string;
};

export const useGetDocumentAssessmentResultAuditById = createQueryHook<
  UseGetDocumentAssessmentResultAuditByIdArgs,
  GetDocumentAssessmentResultAuditByIdResponseRow[],
  AuditLogQueryResult<
    'document_assessment_result_audit',
    GetDocumentAssessmentResultAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDocumentAssessmentResultAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    document_assessment_result_audit: data,
  }),
  graphqlDocument: GetDocumentAssessmentResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
